import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControl, MenuItem, Select, styled } from '@mui/material';

export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isHidden',
})(({ isHidden }) => ({
  display: isHidden && 'none',
}));

export const SelectStyled = styled(Select, {
  shouldForwardProp: (prop) =>
    prop !== 'isSubmitting' &&
    prop !== 'isValidating' &&
    prop !== 'submitCount' &&
    prop !== 'initialValues' &&
    prop !== 'initialErrors' &&
    prop !== 'initialTouched' &&
    prop !== 'initialStatus' &&
    prop !== 'handleBlur' &&
    prop !== 'handleChange' &&
    prop !== 'handleReset' &&
    prop !== 'handleSubmit' &&
    prop !== 'resetForm' &&
    prop !== 'setErrors' &&
    prop !== 'setFormikState' &&
    prop !== 'setFieldTouched' &&
    prop !== 'setFieldValue' &&
    prop !== 'setFieldError' &&
    prop !== 'setStatus' &&
    prop !== 'setSubmitting' &&
    prop !== 'setTouched' &&
    prop !== 'setValues' &&
    prop !== 'submitForm' &&
    prop !== 'validateForm' &&
    prop !== 'validateField' &&
    prop !== 'isValid' &&
    prop !== 'unregisterField' &&
    prop !== 'registerField' &&
    prop !== 'getFieldProps' &&
    prop !== 'getFieldMeta' &&
    prop !== 'getFieldHelpers' &&
    prop !== 'validateOnBlur' &&
    prop !== 'validateOnChange' &&
    prop !== 'validateOnMount' &&
    prop !== 'initialValue' &&
    prop !== 'initialError' &&
    prop !== 'touched' &&
    prop !== 'dirty',
})(({ open, theme, value, placeholder }) => ({
  width: '100%',
  height: '32px',
  border: 'none',

  '&:focus': {
    border: 'none',
  },
  '& fieldset': {
    border: `1px solid ${theme.palette.colors.borderLine}`,
  },
  '&:hover': {
    color: theme.palette.colors.highlight,
    '& svg': {
      color: theme.palette.colors.highlight,
    },
    '& .MuiSelect-select': {
      color: theme.palette.colors.highlight,
    },
  },
  '& .MuiSelect-select': {
    color: open
      ? theme.palette.colors.highlight
      : theme.palette.colors.onSecondaryAndDetailBackground,
    fontWeight: 500,
    padding: '4px 0 5px 8px',
    fontSize: '12px',
    backgroundColor: theme.palette.colors.secondaryBackground,
  },
  '& .MuiSelect-nativeInput': {
    opacity: placeholder && !value && 1,
    border: 0,
    bottom: 'unset',
    paddingLeft: '8px',
    backgroundColor: theme.palette.colors.secondaryBackground,

    '&::placeholder': {
      fontSize: '12px',
      fontStyle: 'italic',
      color: theme.palette.colors.placeholderText,
    },
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.colors.mainFocused,
  },
  'label + &': {
    marginTop: '18px',
  },
  '&.Mui-disabled': {
    '& fieldset': {
      border: `1px solid ${theme.palette.colors.secondaryDisabledText}`,

      '&.MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.colors.secondaryDisabledText,
      },
    },
    '& .MuiSelect-select': {
      backgroundColor: theme.palette.colors.secondaryDisabledBackground,
      WebkitTextFillColor: `${theme.palette.colors.secondaryDisabledText}`,
    },
    '& .MuiSelect-nativeInput': {
      backgroundColor: theme.palette.colors.secondaryDisabledBackground,

      '&::placeholder': {
        color: theme.palette.colors.secondaryDisabledText,
      },
    },
    '& svg': {
      color: theme.palette.colors.secondaryDisabledText,
    },
  },
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: '28px',
  paddingLeft: '8px',
  paddingRight: '8px',
  fontSize: '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  '& svg': {
    visibility: 'hidden',
  },
  '&:hover': {
    backgroundColor: theme.palette.colors.disabledAndHoverOnInfoBackground,
  },
  '&.Mui-selected': {
    fontWeight: 'bold',

    backgroundColor: theme.palette.colors.infoBackground,
    '&.Mui-focusVisible': { background: theme.palette.colors.infoBackground },
    '& svg': {
      visibility: 'visible',
    },
    '&:hover': {
      backgroundColor: theme.palette.colors.disabledAndHoverOnInfoBackground,
    },
  },
}));

export const CheckIconStyled = styled(FontAwesomeIcon)(() => ({
  visibility: 'hidden',
}));

export const ArrowIconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'disabled',
})(({ theme, open, disabled }) => ({
  color: open
    ? theme.palette.colors.highlight
    : theme.palette.colors.onSecondaryAndDetailBackground,
  position: 'absolute',
  right: '8px',
  fontSize: '16px',
  cursor: 'pointer',
  pointerEvents: disabled ? 'none' : 'auto',

  '&.MuiSelect-select': {
    color: 'red',
  },
}));
